<div class="container">

    
    <h6 class="mt-4" *ngIf="eventString">
        Your Appointment has been downloaded.<br/>Open the appointment in your calendar application to import it.</h6>
    <br/>

    <table class="table">
        <tbody>
        <tr><td>Treatment</td><td>{{appointment.treatmentName}}</td></tr>
        <tr><td>Time</td><td>{{appointment.startTime | date}}</td></tr>
        <tr><td>Duration</td><td>{{appointment.duration}} mins</td></tr>
        <tr><td>With</td><td>{{appointment.staffName}}</td></tr>
        <tr><td>Location</td><td>{{clinicDetails.name}}, {{clinicDetails.address1}}, {{clinicDetails.postcode}}</td></tr>
        </tbody>
    </table>

    <div class="mb-3">
        <button mat-raised-button color="primary" (click)="downloadAppointment()">
            <span class="material-icons">event</span>&nbsp;Download Appointment
        </button>
    </div>
   
</div>

